/* import __COLOCATED_TEMPLATE__ from './video-inserter.hbs.js'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { parseUrl } from '@intercom/composer-core';
let VideoInserter = (_class = class VideoInserter extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "url", _descriptor, this);
    _initializerDefineProperty(this, "showError", _descriptor2, this);
  }
  focus(element) {
    element.focus();
  }
  clearError() {
    this.showError = false;
  }
  insertVideoBlock(url) {
    let parsedUrl = parseUrl(url);
    if (parsedUrl.isValid) {
      this.args.insertBlock({
        type: 'video',
        provider: parsedUrl.provider,
        id: parsedUrl.id
      });
    } else {
      this.showError = true;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "url", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "focus", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focus"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clearError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clearError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "insertVideoBlock", [action], Object.getOwnPropertyDescriptor(_class.prototype, "insertVideoBlock"), _class.prototype), _class);
export { VideoInserter as default };